/**
 * Runtime environment detection for WeChat H5 / Capacitor App / plain browser.
 */

function getCapacitor() {
    if (typeof window === 'undefined') {
        return null;
    }
    return window.Capacitor || null;
}

function is_native() {
    const cap = getCapacitor();
    return !!(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
}

function is_weixin() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent.toLowerCase();
    return new String(ua.match(/MicroMessenger/i)) === 'micromessenger';
}

function is_app() {
    return is_native();
}

/** App or plain browser — not WeChat JSBridge */
function uses_native_bridge() {
    return is_native();
}

function platform_name() {
    if (is_native()) {
        const cap = getCapacitor();
        return (cap.getPlatform && cap.getPlatform()) || 'native';
    }
    if (is_weixin()) {
        return 'weixin';
    }
    return 'web';
}

/**
 * User-facing channel for notifications copy.
 * App → App 推送；微信 → 微信消息；其它 → 消息通知
 */
function notify_channel_label() {
    if (is_native()) {
        return 'App';
    }
    if (is_weixin()) {
        return '微信';
    }
    return '';
}

export const env = {
    getCapacitor,
    is_native,
    is_weixin,
    is_app,
    uses_native_bridge,
    platform_name,
    notify_channel_label
};
